<div class="status" [style.background]="_background"></div>